import { render, staticRenderFns } from "./AddEditNotification.vue?vue&type=template&id=4aed13f4"
import script from "./AddEditNotification.vue?vue&type=script&lang=js"
export * from "./AddEditNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports